export class UpdateLetterRequest {
    letterContent: string;
    letterId: number;
}